<wl-homebattery-ui
  [rendering]="rendering()"
  [trackToolConfig]="trackToolConfig"
  [homeBatteryForm]="homeBatteryForm"
  [addressCheckService]="addressCheckService"
  (submitForm)="submit()"
  (openModal)="openModal()"
></wl-homebattery-ui>
